<template>
  <div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button icon="fa fa-plus" @click="insertEvent()">新增</vxe-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      border
      resizable
      row-key
      show-overflow
      highlight-hover-row
      ref="xTable"
      :data="tableData.rows"
      :loading="loading"
      :cell-style="cellStyle"
    >
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="title" title="工厂名称"></vxe-table-column>
      <vxe-table-column
        field="validBefore"
        title="到期时间"
        :formatter="['dateTime', 'yyyy-MM-dd']"
      ></vxe-table-column>
      <vxe-table-column
        field="created"
        title="创建时间"
        formatter="dateTime"
      ></vxe-table-column>
      <vxe-table-column
        field="updated"
        title="修改时间"
        formatter="dateTime"
      ></vxe-table-column>
      <vxe-table-column title="操作" width="100" show-overflow>
        <template v-slot="{ row }">
          <vxe-button
            type="text"
            icon="fa fa-edit"
            @click="editEvent(row)"
          ></vxe-button>
          <vxe-button
            type="text"
            icon="fa fa-trash-o"
            @click="removeEvent(row)"
          ></vxe-button>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      perfect
      :current-page.sync="tableData.page"
      :page-size.sync="tableData.pageSize"
      :total="tableData.totalResult"
      @page-change="pageChange"
    >
    </vxe-pager>

    <vxe-modal
      v-model="showEdit"
      :title="selectRow ? '编辑&保存' : '新增&保存'"
      width="400"
      min-width="300"
      min-height="150"
      :loading="submitLoading"
      resize
      destroy-on-close
    >
      <template v-slot>
        <vxe-form
          :data="formData"
          :items="items"
          :rules="rules"
          title-align="right"
          title-width="160"
          @submit="submitEvent"
        ></vxe-form>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import Factory from '../models/factory'
import FactoryService from '../services/factory.service'

export default {
  data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: {},
      selectRow: null,
      showEdit: false,
      formData: {
        id: null,
        title: null,
        validBefore: null,
        adminAccount: null,
        adminPassword: null,
        adminPasswordConfirm: null
      },
      rules: {},
      items: [],
      editFormRules: {
        title: [
          { required: true, message: '请输入名称' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符' }
        ]
      },
      newFormRules: {
        title: [
          { required: true, message: '请输入名称' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符' }
        ],
        adminAccount: [
          { required: true, message: '请输入管理员账号' },
          {
            pattern: '^[a-z0-9]{1,20}$',
            message: '长度在 1 到 20 个小写字母或数字'
          }
        ],
        adminPassword: [
          { required: true, message: '请输入管理员账号密码' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符' }
        ],
        adminPasswordConfirm: [
          { required: true, message: '请确认管理员账号密码' },
          { validator: this.checkPassword }
        ]
      },
      editFormItems: [
        {
          field: 'title',
          title: '工厂名称',
          span: 24,
          itemRender: { name: '$input', props: { placeholder: '请输入名称' } }
        },
        {
          field: 'validBefore',
          title: '到期时间',
          span: 24,
          itemRender: {
            name: '$input',
            props: { type: 'date', placeholder: '请输入到期时间' }
          }
        },
        {
          align: 'center',
          span: 24,
          titleAlign: 'left',
          itemRender: {
            name: '$buttons',
            children: [
              { props: { type: 'submit', content: '提交', status: 'primary' } }
            ]
          }
        }
      ],
      newFormItems: [
        {
          field: 'title',
          title: '工厂名称',
          span: 24,
          itemRender: { name: '$input', props: { placeholder: '请输入名称' } }
        },
        {
          field: 'adminAccount',
          title: '管理员账号',
          span: 24,
          itemRender: {
            name: '$input',
            props: { placeholder: '请输入管理员账号' }
          }
        },
        {
          field: 'adminPassword',
          title: '管理员账号密码',
          span: 24,
          itemRender: {
            name: '$input',
            props: { type: 'password', placeholder: '请输入管理员账号密码' }
          }
        },
        {
          field: 'adminPasswordConfirm',
          title: '管理员账号密码',
          span: 24,
          itemRender: {
            name: '$input',
            props: { type: 'password', placeholder: '请确认管理员账号密码' }
          }
        },
        {
          align: 'center',
          span: 24,
          titleAlign: 'left',
          itemRender: {
            name: '$buttons',
            children: [
              { props: { type: 'submit', content: '提交', status: 'primary' } }
            ]
          }
        }
      ]
    }
  },
  async mounted() {
    this.loading = true
    try {
      const response = await FactoryService.get()
      this.tableData = response.data
    } catch {
      this.tableData = {}
    }
    this.loading = false
  },
  methods: {
    checkPassword({ itemValue }) {
      if (itemValue !== this.formData.adminPassword) {
        return new Error('两次密码输入不一致')
      }
    },
    insertEvent() {
      this.items = this.newFormItems
      this.rules = this.newFormRules
      this.formData = {}
      this.selectRow = null
      this.showEdit = true
    },
    editEvent(row) {
      this.items = this.editFormItems
      this.rules = this.editFormRules
      this.formData = {
        id: row.id,
        title: row.title,
        validBefore: row.validBefore
      }
      this.selectRow = row
      this.showEdit = true
    },
    removeEvent(row) {
      this.$XModal.confirm('您确定要删除该数据?').then(async (type) => {
        if (type === 'confirm') {
          this.loading = true
          const factory = new Factory()
          Object.assign(factory, row)
          try {
            await FactoryService.delete(factory)
            this.showEdit = false
            const response = await FactoryService.get(
              this.tableData.page,
              this.tableData.pageSize
            )
            this.tableData = response.data
            // this.$refs.xTable.remove(row)
          } catch {}
          this.loading = false
        }
      })
    },
    async submitEvent() {
      this.submitLoading = true
      const factory = new Factory()
      Object.assign(factory, this.formData)

      if (this.selectRow) {
        try {
          const response = await FactoryService.update(factory)
          this.showEdit = false
          if (response.data) {
            Object.assign(this.selectRow, response.data.data)
          } else {
            Object.assign(this.selectRow, this.formData)
          }
        } catch {}
      } else {
        try {
          const response = await FactoryService.create(factory)
          this.showEdit = false
          this.$refs.xTable.insert(response.data.data)
        } catch {}
      }
      this.submitLoading = false
    },
    async pageChange({ currentPage, pageSize }) {
      this.loading = true
      try {
        const response = await FactoryService.get(currentPage, pageSize)
        this.tableData = response.data
      } catch {
        this.tableData = {}
      }
      this.loading = false
    },
    cellStyle({ row, rowIndex, column }) {
      if (column.property === 'validBefore') {
        if (row.validBefore && row.status === 0) {
          return {
            backgroundColor: '#f8d7da',
            color: '#721c24'
          }
        } else if (row.validBefore && row.status === 2) {
          return {
            backgroundColor: '#fff3cd',
            color: '#856404'
          }
        }
      }
    }
  }
}
</script>
